/** Tons discretos para status, prioridade e tags no atendimento. */

import { statusBadgeClass } from './statusBadge';
import type { StatusBadgeTone } from './StatusBadgeTone';

export type SupportBadgeTone = StatusBadgeTone;

export { statusBadgeClass as supportBadgeClass };

export function ticketStatusTone(status: string): SupportBadgeTone {
  switch (status) {
    case 'New':
    case 'Triaged':
      return 'neutral';
    case 'InProgress':
      return 'info';
    case 'PendingCustomer':
    case 'Reopened':
      return 'caution';
    case 'Resolved':
    case 'Closed':
      return 'success';
    default:
      return 'neutral';
  }
}

export function ticketPriorityTone(priority: string): SupportBadgeTone {
  switch (priority) {
    case 'High':
      return 'caution';
    case 'Critical':
      return 'danger';
    default:
      return 'neutral';
  }
}

export function ticketSlaTone(slaState: string): SupportBadgeTone {
  switch (slaState) {
    case 'Breached':
      return 'danger';
    case 'Warning':
      return 'caution';
    case 'Ok':
      return 'success';
    default:
      return 'neutral';
  }
}

export function ticketChannelTone(): SupportBadgeTone {
  return 'neutral';
}
